export const DEFAULT_PAGES = [
  {
    path: '/about',
    label: 'About',
    navLabelKey: 'nav.about',
    footerLabelKey: 'footer.about',
    showInNav: true,
    footerSection: 'quick',
  },
  {
    path: '/how-to-play',
    label: 'How to Play',
    navLabelKey: 'nav.howToPlay',
    footerLabelKey: 'footer.howToPlay',
    showInNav: true,
    footerSection: 'quick',
  },
  {
    path: '/winners',
    label: 'Winners',
    navLabelKey: 'nav.winners',
    footerLabelKey: 'footer.winners',
    showInNav: true,
    footerSection: 'quick',
  },
  {
    path: '/draws',
    label: 'Draws',
    navLabelKey: 'nav.draws',
    footerLabelKey: 'footer.draws',
    showInNav: true,
    footerSection: 'quick',
  },
  {
    path: '/faq',
    label: 'FAQ',
    navLabelKey: 'nav.faq',
    footerLabelKey: 'footer.faq',
    showInNav: false,
    footerSection: 'quick',
  },
  {
    path: '/contact',
    label: 'Contact Us',
    navLabelKey: 'nav.contact',
    footerLabelKey: 'footer.contact',
    showInNav: false,
    footerSection: 'support',
  },
  {
    path: '/terms',
    label: 'Terms',
    navLabelKey: 'footer.terms',
    footerLabelKey: 'footer.terms',
    showInNav: false,
    footerSection: 'support',
  },
  {
    path: '/privacy',
    label: 'Privacy',
    navLabelKey: 'footer.privacy',
    footerLabelKey: 'footer.privacy',
    showInNav: false,
    footerSection: 'support',
  },
  {
    path: '/responsible-gaming',
    label: 'Responsible Gaming',
    navLabelKey: 'footer.responsibleGaming',
    footerLabelKey: 'footer.responsibleGaming',
    showInNav: false,
    footerSection: 'support',
  },
];

function isPlainObject(value) {
  return Boolean(value) && typeof value === 'object' && !Array.isArray(value);
}

export function getDefaultPageVisibility(rawValue) {
  if (!rawValue) return null;

  if (typeof rawValue === 'string') {
    try {
      return getDefaultPageVisibility(JSON.parse(rawValue));
    } catch {
      return null;
    }
  }

  if (!isPlainObject(rawValue)) return null;

  const normalized = {};

  for (const page of DEFAULT_PAGES) {
    if (rawValue[page.path] === false) {
      normalized[page.path] = false;
    }
  }

  return Object.keys(normalized).length > 0 ? normalized : null;
}

export function isDefaultPageEnabled(path, visibilityMap) {
  return visibilityMap?.[path] !== false;
}

export function toggleDefaultPageVisibility(currentVisibility, path, enabled) {
  const nextVisibility = { ...(currentVisibility || {}) };

  if (enabled) {
    delete nextVisibility[path];
  } else {
    nextVisibility[path] = false;
  }

  return getDefaultPageVisibility(nextVisibility);
}